import { downloadBlob } from "@/lib/downloadBlob";

/** Escape a single CSV cell (RFC 4180). */
function escapeCsvCell(value: string): string {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

/** Build a CSV document from headers and row values. */
export function buildCsv(headers: string[], rows: string[][]): string {
  return [headers, ...rows]
    .map((row) => row.map(escapeCsvCell).join(","))
    .join("\n");
}

/** Trigger a browser download of a CSV file (UTF-8 with BOM for Excel). */
export function downloadCsv(
  filename: string,
  headers: string[],
  rows: string[][],
): void {
  const csv = buildCsv(headers, rows);
  const blob = new Blob(["\uFEFF" + csv], {
    type: "text/csv;charset=utf-8;",
  });
  downloadBlob(blob, filename);
}
